export default "__VITE_ASSET__CkHPEaQz__"